// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { KSK2120_R01Dto } from "./Dto_KSK2120_R01";
import { showWarning } from "src/utils/toast/toastUtil";

// BOM 컬럼 헤더명
export const headerNames_KSK2120_R01: Record<string, string> = {
	rowIndex: "",
	// productWorkNo: '작업지시번호',
	feederNo: '피더번호',
	childItemcd: '자품목코드',
	itemNm: '품명',
	coordinateUsage: '좌표사용량',
	materialIntype: '공급구분',
	lotNo: '장착Lot No',
	lotQty: '수량',
	remark: '요청사항',
};

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: KSK2120_R01Dto,
  updateKSK2120_R01Detail: (index: number, data: KSK2120_R01Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateKSK2120_R01Detail(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('childItemcd', originalData.childItemcd);
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalKSK2120_R01DetailList: KSK2120_R01Dto[],
  deletedKSK2120_R01DetailList: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalKSK2120_R01DetailList.find(item => item.valueIndex === params.data?.valueIndex);
  if (params.data?.childItemcd && deletedKSK2120_R01DetailList.includes(params.data.childItemcd)) return false;
  return true;
}
	
// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}

// 중복 체크
export function isDuplicateChildItemcd(
  list: KSK2120_R01Dto[],
  itemCd: string,
  valueIndex: number
) {
  return list.filter(item => item.childItemcd === itemCd && item.valueIndex !== valueIndex).length > 0;
}

// 손실율/필요수량 자동 계산 로직은 제거되었습니다.